import React, { useEffect, useState } from "react";
import { getOutOfTimelineDetails } from "../../../services/AppService";
import { useNavigate } from "react-router-dom";
import PageFade from "../../../components/Login/PageFade";
import closeButton from '../../../assets/images/close.png';
import { useTranslation } from "react-i18next";

const OutOfTimelineDetailsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => { fetchDetails(); }, []);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const data = await getOutOfTimelineDetails();
            setItems(data.content || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-blue">{t('pageTitles.outOfTimeline')}</h4>
                    <img src={closeButton} className="w-6 h-6 cursor-pointer" onClick={() => navigate(-1)} alt="close" />
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full border text-[13px] ctable text-center border-collapse">
                        <thead>
                            <tr className="bg-[#a0adf1] text-white">
                                <th className="p-3 border">{t('tables.srNo')}</th>
                                <th className="p-3 border text-left w-72">{t('work.workName')}</th>
                                <th className="p-3 border">{t('work.tenderId')}</th>
                                <th className="p-3 border">{t('work.workOrderNo')}</th>
                                <th className="p-3 border">{t('work.duration')}</th>
                                <th className="p-3 border">{t('work.orderDate')}</th>
                                <th className="p-3 border">{t('work.startDate')}</th>
                                <th className="p-3 border">{t('work.endDate')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="9" className="p-10">Checking Deadlines...</td></tr>
                            ) : items.length === 0 ? (
                                <tr><td colSpan="9" className="p-10 text-gray-500">All works are within timeline.</td></tr>
                            ) : (
                                items.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className="p-3 border">{idx + 1}</td>
                                        <td className="p-3 border text-left font-bold">{item.workTitle}</td>
                                        <td className="p-3 border">{item.tenderId}</td>
                                        <td className="p-3 border">{item.workOrderNo}</td>
                                        <td className="p-3 border">{item.duration} Days</td>
                                        <td className="p-3 border">{item.workOrderDate}</td>
                                        <td className="p-3 border">{item.workStartDate}</td>
                                        <td className="p-3 border font-bold">{item.workEndDate}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </PageFade>
    );
};

export default OutOfTimelineDetailsPage;